module.exports = __webpack_public_path__ + "img/LivingRoom.156cdc38.jpg";